import { useWorkspace } from 'app/_providers/WorkspaceProvider';

import { usePathname } from 'next/navigation';

const workspaceHomePathPattern = /^\/organizations\/([^/]+)\/workspaces\/([^/]+)/;

export const workspaceHomePathFromPathname = (pathname: string | null | undefined): string | undefined => {
  if (!pathname) {
    return undefined;
  }

  const match = workspaceHomePathPattern.exec(pathname);

  if (!match) {
    return undefined;
  }

  return `/organizations/${match[1]}/workspaces/${match[2]}`;
};

export const useWorkspaceHomePath = (): string | undefined => {
  const { pathname: currentWorkspacePath, name: currentWorkspaceName, workspaces } = useWorkspace();
  const pathname = usePathname();

  if (currentWorkspacePath) {
    return currentWorkspacePath;
  }

  const currentWorkspace = workspaces?.find((workspace) => workspace.name === currentWorkspaceName);

  if (currentWorkspace?.pathname) {
    return currentWorkspace.pathname;
  }

  const mainWorkspace = workspaces?.find((workspace) => workspace.name === 'main');

  if (mainWorkspace?.pathname) {
    return mainWorkspace.pathname;
  }

  return workspaceHomePathFromPathname(pathname);
};
